import { HTMLAttributes, memo } from "react";
import classNames from "classnames";
import { EmptyStateSize } from "../../EmptyState";

import { ReactComponent as ErrorIcon } from "./icons/errorBannerIcon.svg";

import styles from "./styles.module.scss";

export type GlobalErrorBannerIconProps = HTMLAttributes<HTMLDivElement> & {
  size?: EmptyStateSize
}

export const GlobalErrorBannerIcon = memo<GlobalErrorBannerIconProps>(({ size, className, ...props }) => {
  return (
    <div
      {...props}
      className={classNames(className, styles.root, styles[size as keyof typeof styles])}
    >
      <ErrorIcon />
    </div>
  );
});